<template>
	<CardHighlightRow
		bg-color="bg-ternary"
		class="max-sm:text-xs orderSummaryCurrencyRowComponent">
		<ClientOnly>
			<p>{{ $t("orderSummaryPrices", { currencyName: currency.namePlural }) }}</p>
			<p
				class="max-sm:hidden h-4 gap-1 flex justify-end items-center w-20 cursor-pointer"
				@click="clickedCurrency">
				<img
					class="h-full inline"
					loading="lazy"
					:src="currency.flag" />
				{{ currency.symbol + currency.code }}
			</p>
		</ClientOnly>
	</CardHighlightRow>
</template>

<script setup>
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"
	import { useNuxtApp } from "#app"
	import { OPEN_CURRENCY_SELECTOR } from "assets/events/checkout.js"

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)
	const { $eventBus } = useNuxtApp()

	const clickedCurrency = () => {
		$eventBus.$emit(OPEN_CURRENCY_SELECTOR)
		window.scrollTo({ top: 0, behavior: "smooth" })
	}
</script>

<style scoped></style>
